
import AppRoutes from "./Routes/RutasSistemaContable";

function App() {
  return (
     
      <AppRoutes />
  );
}

export default App;
